import { NavLink, useLocation } from 'react-router-dom';

import { HeaderMenuItemConfig } from '../Header/headers.config';

interface PassedProps<RouteKeys extends string> {
  headerConfig: HeaderMenuItemConfig<RouteKeys>;
  to: string;
}

export const SubHeaderMenuItem = <RouteKeys extends string>({
  headerConfig,
  to,
}: PassedProps<RouteKeys>) => {
  const location = useLocation();

  const isManuallyActive =
    to === 'active_trades/all' && location.pathname.startsWith('/marketplace/active_trades');

  const baseClasses =
    'px-6 py-[10px] text-gray-500 text-xsm border-b-2 no-underline transition-colors duration-200';
  const hoverClasses = 'hover:text-white light:hover:text-black';
  const activeClasses = 'border-accent-default text-foreground-default light:text-black';
  const disabledClasses = 'pointer-events-none text-gray-400';

  const inactiveBorder = 'border-transparent-0';

  return (
    <li className="flex list-none items-center self-end">
      <NavLink
        to={to}
        className={({ isActive }) =>
          headerConfig.disabled
            ? `${baseClasses} ${disabledClasses}`
            : `${baseClasses} ${hoverClasses} ${
                isActive || isManuallyActive ? `${activeClasses}` : `${inactiveBorder}`
              }`
        }
      >
        {headerConfig.label}
      </NavLink>
    </li>
  );
};
